import { call, put } from 'redux-saga/effects';

import api from 'api';
import { IGetAuthTokenResponse } from 'api/components/Auth/types';

import sentry from 'services/Sentry/SentryInstance';

import { getAuthTokenError, getAuthTokenSuccess } from '../actions';

export function* getAuthTokenSaga() {
    try {
        const { auth_token }: IGetAuthTokenResponse = yield call(api.auth.getAuthToken);

        yield put(getAuthTokenSuccess(auth_token));
    } catch (error: any) {
        yield put(getAuthTokenError());

        sentry.sentrySagaLog(error, 'getAuthTokenSaga');
    }
}
